import { drawingStore } from "../store";

export const getMultiSelected = () => {
  const state = drawingStore.reduxStore?.store.getState();
  if (!state) return;

  return state.interactions.multiSelect;
};
